import { useSectionNav } from "@/lib/scroll";

const links = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Projects", id: "projects" },
  { label: "Contact", id: "contact" },
];

export default function Footer() {
  const sectionNav = useSectionNav();
  return (
    <footer data-testid="site-footer" className="bg-black text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-10 pb-12 border-b border-zinc-800">
          <div>
            <p className="font-heading text-xl font-medium tracking-tight">Saurabh Decor Creations</p>
            <p className="mt-3 text-sm text-zinc-400">Civil | Interior | Modular Kitchen | Restoration</p>
            <p className="mt-2 text-sm text-zinc-400">Mumbai, Maharashtra, India</p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3" data-testid="footer-menu">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`footer-link-${l.id}`}
                onClick={() => sectionNav(l.id)}
                className="text-sm text-zinc-400 hover:text-white transition-colors duration-300"
              >
                {l.label}
              </button>
            ))}
          </nav>
          <div className="flex flex-col gap-2">
            <a
              data-testid="footer-email-link"
              href="mailto:srbh9549@gmail.com"
              className="text-sm text-zinc-400 hover:text-white transition-colors duration-300"
            >
              srbh9549@gmail.com
            </a>
            <a
              data-testid="footer-phone-link"
              href="tel:+918850727221"
              className="text-sm text-zinc-400 hover:text-white transition-colors duration-300"
            >
              +91 88507 27221
            </a>
          </div>
        </div>
        <p className="pt-8 text-xs text-zinc-500">&copy; 2026 Saurabh Decor Creations. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
